window.DirectionPageMap = {
  init: function() {
    var points = $('#geopoints').data('points');
    if (points.length === 0) return;

    var geopoints = document.getElementById('geopoints');

    var options = {
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      center: new google.maps.LatLng(points[0].lat, points[0].lng),
      disableDefaultUI: true,
      scrollwheel: false,
      draggable: false
    };

    var map = new google.maps.Map(geopoints, options);

    var addMarker = function(point) {
      return new google.maps.Marker({
        position: new google.maps.LatLng(point.lat, point.lng),
        map: map,
        draggable: false
      });
    }

    if (points.length > 1) {
      var bounds = new google.maps.LatLngBounds();

      for (var i = 0; i < points.length; i++) {
        var marker = addMarker(points[i])
        bounds.extend(marker.position);
      }

      map.fitBounds(bounds);
    } else {
      addMarker(points[0])
    }

    map.panBy(geopoints.offsetWidth * -0.15, 0);
    google.maps.event.trigger(map, 'resize');
  }
};
